import { injectable, inject } from "tsyringe";
import { TOKEN_IWrapTime, type IWrapTime } from "./WrapTime";
import { type IEnvironment, TOKEN_IEnvironment } from "./IEnvironment";
import log from "loglevel";
import { type IUserIdentity, TOKEN_IUserIdentity } from "./UserIdentity";
import { TOKEN_IWrapAuth0, type IWrapAuth0 } from "./WrapAuth0";

export const TOKEN_ISecureServerCalls = Symbol('ISecureServerCalls');

export interface AuthData {
    publicKey: string;
    nonce: string;
    sign: string;
    bearerToken?: string;
}

/*
 * Determine API URL endpoint to use for server calls and construction of authentication data using public/private keys and nonce
 */
export interface ISecureServerCalls {
    getApiBaseUrl(projectId: string): Promise<string>;
    getRealtimeBaseUrl(projectId: string): Promise<string>;
    getAssistantBaseUrl(projectId: string): Promise<string>;
    AuthData(): Promise<AuthData>;
}

@injectable()
export class SecureServerCalls implements ISecureServerCalls {

    constructor(
        @inject(TOKEN_IWrapTime) private wrapTime: IWrapTime,
        @inject(TOKEN_IUserIdentity) private userIdentity: IUserIdentity,
        @inject(TOKEN_IEnvironment) private environment: IEnvironment,
        @inject(TOKEN_IWrapAuth0) private wrapAuth0: IWrapAuth0,
    ) { }

    // private async hashProjectId(projectId: string): Promise<number> {
    //     const encoder = new TextEncoder();
    //     const data = encoder.encode(projectId);
    //     const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    //     const hashArray = Array.from(new Uint8Array(hashBuffer));
    //     return hashArray[0];
    // }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private async internalApiPort(_: string) {
        if (this.environment.isProd) {
            // const hash = await this.hashProjectId(projectId);
            // Using bitwise AND with 1 to check if the hash is even or odd
            // return (hash % 2) === 0 ? '1001' : '1000';
            return '';
        }
        return "5198";
    }

    getApiBaseUrl = async (projectId: string) => {
        return `${this.environment.backendUrl}:${await this.internalApiPort(projectId)}`;
    }

    getRealtimeBaseUrl = async (projectId: string) => {
        return `${this.environment.backendUrl}:${await this.internalApiPort(projectId)}`;
    }

    getAssistantBaseUrl = async (projectId: string) => {
        return `${this.environment.backendUrl}:${await this.internalApiPort(projectId)}`;
    }

    AuthData = async (): Promise<AuthData> => {
        log.debug("Preparing auth data for a server call");
        const publicKey = await this.userIdentity.publicKey();
        const nonce = this.wrapTime.getCurrentUnixTimestamp().toString();
        const sign = await this.userIdentity.sign(nonce);
        const bearerToken = await this.wrapAuth0.getTokenSilently();

        return { publicKey: publicKey.publicKeyStr, nonce, sign, bearerToken };
    }
}